// SPDX-License-Identifier: AGPL-3.0-or-later

import {PRODUCT_NAME} from '@app/features/app/config/ProductConstants';
import {resolveAppShellBranding} from '@app/features/app/state/AppShellBranding';
import RuntimeConfig from '@app/features/app/state/RuntimeConfig';
import styles from '@app/features/auth/components/YunblyAuthBrand.module.css';
import {FluxerIcon} from '@app/features/ui/components/icons/FluxerIcon';
import {FluxerWordmark} from '@app/features/ui/components/icons/FluxerWordmark';
import {observer} from 'mobx-react-lite';

export const YunblyAuthBrand = observer(function YunblyAuthBrand() {
	const branding = resolveAppShellBranding(RuntimeConfig.getSnapshotOrNull());
	return (
		<div className={styles.brand} data-flx="auth.components.yunbly-brand">
			{branding.productName === PRODUCT_NAME || branding.wordmarkUrl !== null ? (
				<FluxerWordmark
					height={36}
					style={{height: 36, width: 'auto', maxWidth: '100%'}}
					data-flx="auth.yunbly-auth-brand.fluxer-wordmark"
				/>
			) : (
				<>
					<FluxerIcon width={40} height={40} aria-hidden="true" data-flx="auth.yunbly-auth-brand.fluxer-icon" />
					<span data-flx="auth.yunbly-auth-brand.span">{branding.productName}</span>
				</>
			)}
		</div>
	);
});
